const M = [
  {
    name: "pageTitle",
    zh: "易付宝-菲律宾便民缴费平台",
    en: "eepay-Philippines convenient payment platform"
  },
  {
    name: "all",
    zh: "全部",
    en: "All"
  },
  {
    name: "home",
    zh: "首页",
    en: "Home"
  },
  {
    name: "wallet",
    zh: "钱包",
    en: "Wallet"
  },
  {
    name: "life",
    zh: "生活",
    en: "Life"
  },
  {
    name: "my",
    zh: "我的",
    en: "Profile"
  },
  {
    name: "setting",
    zh: "设置",
    en: "Setting"
  },
  {
    name: "gotoSetting",
    zh: "去设置",
    en: "go to setting"
  },
  {
    name: "login",
    zh: "登录",
    en: "Login"
  },
  {
    name: "register",
    zh: "注册",
    en: "Register"
  },
  {
    name: "retrievePassword",
    zh: "找回密码",
    en: "Retrieve password"
  },
  {
    name: "forgetPassword",
    zh: "忘记密码",
    en: "Forget"
  },
  {
    name: "AccountPlaceholder",
    zh: "请输入账号或手机号",
    en: "Account/Mobile Number"
  },
  {
    name: "AccountFormat",
    zh: "账号（5-10字母+数字）",
    en: "Account (5-10 letters + numbers)"
  },
  {
    name: "PasswordFormat",
    zh: "密码（8-16字母+数字）",
    en: "Password (8-16 letters + numbers)"
  },
  {
    name: "enterAccount",
    zh: "请输入账号",
    en: "Enter account number"
  },
  {
    name: "enterPassword",
    zh: "请输入密码",
    en: "Enter password"
  },
  {
    name: "enterMobile",
    zh: "请输入手机号",
    en: "Enter mobile number"
  },
  {
    name: "enterVerificationCode",
    zh: "请输入验证码",
    en: "Enter verification code"
  },
  {
    name: "enterPayPsd",
    zh: "请输入支付密码",
    en: "Enter payment password"
  },
  {
    name: "enterConfirmPsd",
    zh: "请输入确认密码",
    en: "Enter confirm password"
  },
  {
    name: "name",
    zh: "姓名",
    en: "Full name"
  },
  {
    name: "enterName",
    zh: "请输入姓名",
    en: "Enter full name"
  },
  {
    name: "enterAliPay",
    zh: "请输入支付宝账户",
    en: "Enter aliPay account"
  },
  {
    name: "bindMobile",
    zh: "请绑定手机号",
    en: "Binding the mobile number"
  },
  {
    name: "verificationCode",
    zh: "验证码",
    en: "Verification Code"
  },
  {
    name: "getItNow",
    zh: "立即获取",
    en: "Click"
  },
  {
    name: "getAgain",
    zh: "重新获取",
    en: "Get again"
  },
  {
    name: "remaining",
    zh: "剩余",
    en: ""
  },
  {
    name: "verification",
    zh: "验证",
    en: "Verification"
  },
  {
    name: "confirm",
    zh: "确定",
    en: "Confirm"
  },
  {
    name: "cancel",
    zh: "取消",
    en: "Cancel"
  },
  {
    name: "save",
    zh: "保存",
    en: "Save"
  },
  {
    name: "delete",
    zh: "删除",
    en: "Delete"
  },
  {
    name: "setPassword",
    zh: "设置密码",
    en: "Set password"
  },
  {
    name: "bindMobilePhone",
    zh: "绑定手机",
    en: "Binding mobile number"
  },
  {
    name: "nextStep",
    zh: "下一步",
    en: "Next Step"
  },
  {
    name: "submit",
    zh: "提交",
    en: "Submit"
  },
  {
    name: "done",
    zh: "完成",
    en: "Done"
  },
  {
    name: "twoPsdInconformity",
    zh: "两次密码输入不一致",
    en: "Two password input is inconsistent"
  },
  {
    name: "mobileNumber",
    zh: "手机号",
    en: "Mobile number"
  },
  {
    name: "modifyBoundMobile",
    zh: "修改绑定手机",
    en: "Modify Binding mobile number"
  },
  {
    name: "changeBoundMobile",
    zh: "更换绑定手机",
    en: "Change Binding mobile number"
  },
  {
    name: "removeBinding",
    zh: "解除绑定",
    en: "Remove binding"
  },
  {
    name: "sureRemoveBinding",
    zh: "您确定要解除绑定吗？",
    en: "Are you sure to remove the binding?"
  },
  {
    name: "Mr",
    zh: "先生",
    en: "Mr."
  },
  {
    name: "Ms",
    zh: "女士",
    en: "Ms."
  },
  {
    name: "share",
    zh: "分享",
    en: "Share"
  },
  {
    name: "noData",
    zh: "暂无数据",
    en: "No data"
  },
  {
    name: "copyLink",
    zh: "复制链接",
    en: "Copy link"
  },
  {
    name: "copySuccess",
    zh: "复制成功",
    en: "Copy success"
  },
  {
    name: "browserNoCopy",
    zh: "该浏览器不支持自动复制",
    en: "Automatic replication is not supported in this browser"
  },
  {
    name: "persons",
    zh: "人",
    en: "persons"
  },
  {
    name: "binding",
    zh: "绑定",
    en: "Binding"
  },
  {
    name: "unbind",
    zh: "解绑",
    en: "Unbind"
  },
  {
    name: "yes",
    zh: "是",
    en: "Yes"
  },
  {
    name: "no",
    zh: "否",
    en: "No"
  },
  {
    name: "haveSet",
    zh: "已设置",
    en: "Have set"
  },
  {
    name: "notSet",
    zh: "未设置",
    en: "Not set"
  },
  {
    name: "selectPayment",
    zh: "选择支付方式",
    en: "Select payment"
  },
  {
    name: "rechargeDiscount",
    zh: "充值优惠",
    en: "Promos"
  },
  {
    name: "discountDesc",
    zh: "优惠说明",
    en: "Discount description"
  },
  {
    name: "balance",
    zh: "账户余额",
    en: "Wallet balance"
  },
  {
    name: "rate",
    zh: "汇率",
    en: "Exchange rate "
  },
  {
    name: "loadNow",
    zh: "立即充值",
    en: "Load now"
  },
  {
    name: "cashinNow",
    zh: "立即充值",
    en: "Cashin now"
  },
  {
    name: "rechargeDetail",
    zh: "充值详情",
    en: "Load details"
  },
  {
    name: "transferDetail",
    zh: "转账详情",
    en: "Transfer detail"
  },
  {
    name: "withdrawalDetail",
    zh: "提现详情",
    en: "Withdrawal detail"
  },
  {
    name: "nothing",
    zh: "无",
    en: "No"
  },
  {
    name: "rechargeAgain",
    zh: "再次充值",
    en: "Load again"
  },
  {
    name: "immediatelyPay",
    zh: "立即支付",
    en: "Immediately pay"
  },
  {
    name: "rechargeRecord",
    zh: "充值记录",
    en: "History"
  },
  {
    name: "rechargeRecord1",
    zh: "充值记录",
    en: "Load history"
  },
  {
    name: "withdrawalRecord",
    zh: "提现记录",
    en: "History"
  },
  {
    name: "withdrawalRecord1",
    zh: "提现记录",
    en: "Withdrawal history"
  },
  {
    name: "transferRecord",
    zh: "转账记录",
    en: "History"
  },
  {
    name: "transferRecord1",
    zh: "转账记录",
    en: "Transfer history"
  },
  {
    name: "reservationRecord",
    zh: "预约记录",
    en: "History"
  },
  {
    name: "reservationRecord1",
    zh: "预约记录",
    en: "Reservation history"
  },
  {
    name: "help",
    zh: "帮助",
    en: "Help"
  },
  {
    name: "selectOperator",
    zh: "选择运营商",
    en: "Select operator"
  },
  {
    name: "enterOperator",
    zh: "请输入运营商",
    en: "Enter operator"
  },
  {
    name: "serviceCharge",
    zh: "手续费",
    en: "Service fee "
  },
  {
    name: "serviceRate",
    zh: "手续费率",
    en: "Service fee rate "
  },
  {
    name: "minServiceCharge",
    zh: "最低手续费",
    en: "Min service fee "
  },
  {
    name: "add",
    zh: "添加",
    en: "Add"
  },
  {
    name: "edit",
    zh: "编辑",
    en: "Edit"
  },
  {
    name: "more",
    zh: "更多",
    en: "More"
  },
  {
    name: "batchRecharge",
    zh: "批量充值",
    en: "Bulk moblie & data loading"
  },
  {
    name: "operatorPackage",
    zh: "运营套餐",
    en: "Operator package"
  },
  {
    name: "year",
    zh: "年",
    en: "year"
  },
  {
    name: "month",
    zh: "月",
    en: "month"
  },
  {
    name: "days",
    zh: "日",
    en: "days"
  },
  {
    name: "days1",
    zh: "天",
    en: "days"
  },
  {
    name: "price",
    zh: "售价",
    en: "Price"
  },
  {
    name: "CNY",
    zh: "元",
    en: "CNY"
  },
  {
    name: "moreDenomination",
    zh: "更多面额",
    en: "More amount option"
  },
  {
    name: "customized",
    zh: "自定义",
    en: "Customized"
  },
  {
    name: "recentChargeAmount",
    zh: "最近充值金额",
    en: "Recently loaded"
  },
  {
    name: "clickContinueRecharge",
    zh: "点击继续充值",
    en: "click to load again"
  },
  {
    name: "clearHistory",
    zh: "清空历史记录",
    en: "clear history"
  },
  {
    name: "payFeesTips",
    zh:
      "注：请严格按照提示要求输入因用户输入错误导致的费用缴纳延期或失误，责任由用户本人承担",
    en:
      "Note: please input in strict accordance with instructions. The user shall be responsible for any delay or error in payment caused by user's input error"
  },
  {
    name: "tips",
    zh: "温馨提示",
    en: "Tips"
  },
  {
    name: "enterAmount",
    zh: "请输入金额",
    en: "Enter amount"
  },
  {
    name: "enterCorrectAmount",
    zh: "请输入正确的金额",
    en: "Enter correct amount"
  },
  {
    name: "amountCannotMin",
    zh: "金额不能小于",
    en: "The amount cannot be less than"
  },
  {
    name: "amountCannotMax",
    zh: "金额不能大于",
    en: "The amount cannot be greater than"
  },
  {
    name: "insufficientAccountBalance",
    zh: "余额不足",
    en: "Balance is not enough"
  },
  {
    name: "balanceInsufficientRecharge",
    zh: "余额不足请充值",
    en: "The balance is insufficient, please cash in the balance first"
  },
  {
    name: "weChat",
    zh: "微信",
    en: "WeChat"
  },
  {
    name: "weChatPay",
    zh: "微信支付",
    en: "WeChat pay"
  },
  {
    name: "pleaseUse",
    zh: "请使用",
    en: "Use "
  },
  {
    name: "scanPay",
    zh: "扫码支付",
    en: " to scan for payment"
  },
  {
    name: "confirmPayment",
    zh: "确认支付",
    en: "Confirm"
  },
  {
    name: "address",
    zh: "地址",
    en: "Address"
  },
  {
    name: "search",
    zh: "搜索",
    en: "Search"
  },
  {
    name: "hotSearch",
    zh: "热门搜索",
    en: "Hot search"
  },
  {
    name: "historySearch",
    zh: "历史搜索",
    en: "History search"
  },
  {
    name: "enterSearchKeyword",
    zh: "请输入搜索关键字",
    en: "Enter search keyword"
  },
  {
    name: "note",
    zh: "备注",
    en: "Note"
  },
  {
    name: "enterNote",
    zh: "请输入备注",
    en: "Enter note"
  },
  {
    name: "refresh",
    zh: "刷新",
    en: "Refresh"
  },
  {
    name: "transactionTime",
    zh: "交易时间",
    en: "Transaction time"
  },
  {
    name: "orderNumber",
    zh: "订单号",
    en: "Order number"
  },
  {
    name: "thirdPartyOrderNumber",
    zh: "第三方订单号",
    en: "Third party order number"
  },
  {
    name: "bill",
    zh: "账单",
    en: "Bill"
  },
  {
    name: "statistics",
    zh: "统计",
    en: "Statistics"
  },
  {
    name: "screen",
    zh: "筛选",
    en: "Filter"
  },
  {
    name: "endTimeCannotLessBeginningTime",
    zh: "结束时间不能小于开始时间",
    en: "The end time cannot be less than the begin time"
  },
  {
    name: "totalExpenditure",
    zh: "总支出",
    en: "Total expenditure"
  },
  {
    name: "totalIncome",
    zh: "总收入",
    en: "Total income"
  },
  {
    name: "daily",
    zh: "每日",
    en: "Daily"
  },
  {
    name: "income",
    zh: "收入",
    en: "Income"
  },
  {
    name: "expenditure",
    zh: "支出",
    en: "Expenditure"
  },
  {
    name: "contactServiceCustomer",
    zh: "联系客服",
    en: "Contact service customer"
  },
  {
    name: "eepay",
    zh: "易付宝",
    en: "eepay"
  },
  {
    name: "back",
    zh: "返回",
    en: "Back"
  },
  {
    name: "downloadTemplate",
    zh: "下载模板",
    en: "Download template"
  },
  {
    name: "importSample",
    zh: "导入示例",
    en: "Import sample"
  },
  {
    name: "today",
    zh: "今日",
    en: "Today"
  },
  {
    name: "yesterday",
    zh: "昨天",
    en: "Yesterday"
  },
  {
    name: "recent7days",
    zh: "最近一周",
    en: "Recent 7days"
  },
  {
    name: "recent30days",
    zh: "最近一月",
    en: "Recent 30days"
  },
  {
    name: "startTime",
    zh: "开始时间",
    en: "Start time"
  },
  {
    name: "endTime",
    zh: "结束时间",
    en: "End time"
  },
  {
    name: "transactionType",
    zh: "交易类型",
    en: "Transaction type"
  },
  {
    name: "transactionStatus",
    zh: "交易状态",
    en: "Transaction status"
  },
  {
    name: "transactionMethod",
    zh: "交易方式",
    en: "Transaction method"
  },
  {
    name: "selectDate",
    zh: "时间筛选",
    en: "Select date"
  },
  {
    name: "printList",
    zh: "打印列表",
    en: "Print list"
  },

  {
    name: "succeed",
    zh: "成功",
    en: "Succeed"
  },
  {
    name: "failed",
    zh: "失败",
    en: "Failed"
  },
  {
    name: "items",
    zh: "条",
    en: ""
  },
  {
    name: "refundAmount",
    zh: "应退总额",
    en: "Refund amount"
  },
  {
    name: "enterCorrectInformation",
    zh: "请输入正确的信息",
    en: "Enter correct information"
  },
  {
    name: "noAccountYet",
    zh: "还没有账号？",
    en: "No account yet?"
  },
  {
    name: "scanCodeDownload",
    zh: "扫码下载",
    en: "Scan code to download"
  },
  {
    name: "payPsd",
    zh: "支付密码",
    en: "Payment password"
  },
  {
    name: "loginName",
    zh: "账号/手机登录",
    en: "Account / Mobile Login"
  },
  {
    name: "welcome",
    zh: "欢迎加入易付宝",
    en: "Welcome to eepay"
  },
  {
    name: "accountLogin",
    zh: "账号登录",
    en: "Account Login"
  },
  {
    name: "verificationCodeLogin",
    zh: "验证码登录",
    en: "Verification code login"
  }
];

export default M;
